import "./Partnerships.css";

interface Partner {
  name: string;
  logo: string;
  alt?: string;
}

interface PartnershipsProps {
  title: string;
  subtitle: string;
  partners: Partner[];
}

const Partnerships = ({ title, subtitle, partners }: PartnershipsProps) => {
  return (
    <section className="partnerships-section">
      <div className="container">

        <h2 className="partnerships-title">{title}</h2>
        <p className="partnerships-subtitle">{subtitle}</p>

        <div className="partnerships-logos">
          {partners.map((partner, index) => (
            <div className="partner-logo" key={index}>
              <img
                src={partner.logo}
                alt={partner.alt || partner.name}
              />
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Partnerships;
